<app-navbar></app-navbar>

<div class="content" id="main-content" tabindex="-1">
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<div class="fab-list">

    <!-- First fab is big, others are mini fabs-->


    @for (item of fabService.items; track item) {
        <button mat-fab [matTooltip]="item.label" (click)="item.onClick()">
            <mat-icon>{{ item.icon }}</mat-icon>
        </button>
    }
</div>

<!-- Chatbot Sidebar - Always available globally -->
<app-chatbot 
  [isOpen]="chatbotService.chatbotOpen"
  [mode]="chatbotService.chatbotMode"
  [position]="'end'"
  [width]="chatbotService.chatbotWidth"
  (openedChange)="chatbotService.onChatbotOpenedChange($event)">
</app-chatbot>

<app-cookie-banner></app-cookie-banner>

